const ABOUT_US = 'About Us'
const HOW_IT_WORKS = 'How it works'
const FAQ = 'FAQ'
const PRIVACY_POLICY = 'Privacy Policy'
const COPY_RIGHT = '2021 Vittas International. All Right Reserved'

export { ABOUT_US, HOW_IT_WORKS, FAQ, PRIVACY_POLICY, COPY_RIGHT }
export const FooterWriteup =
  'Our healthcare financing solutions are tailored to meet the unique needs of your business. Apply now to secure the funding you need to run and expand your operations.'
